import { firestoreAction } from 'vuexfire'
import { db, auth } from '@/plugins/firebase'
import {ga} from '@/main'

const state = {
    user: {},
    privateUser: {},
    selected: {}
}
const mutations = {
    SELECT(state, { key, value }) {
        state.selected = { ...state.selected, [key]: value };
    },
    SET_USER(state, user) {
        state.user = user;
    }
}
const actions = {
    bindUser: firestoreAction(async ({ bindFirestoreRef, commit, dispatch, state }, userId) => {
        commit("SELECT", { key: "user", value: userId })
        try {
            await bindFirestoreRef('user', db.collection('users').doc(userId))
        } catch (err) { console.log("user does not exist") }

        if (state.user == null || !state.user.accountCreated) {
            await dispatch("createUser");
            if (state.user == null)
                await bindFirestoreRef('user', db.collection('users').doc(userId))
        }
        dispatch("globalRecommendations/bindRecommendations", null, { root: true });
        await bindFirestoreRef('privateUser', db.collection('users').doc(userId).collection("data").doc('private'))
        await dispatch("social/bindContacts", null, { root: true });
        await dispatch("conversations/bindConversations", null, { root: true });
    }),
    unBindUser: firestoreAction(({ unbindFirestoreRef, commit }) => {
        unbindFirestoreRef('user');
        commit("SET_USER", false);
        unbindFirestoreRef('privateUser');
    }),
    createUser: async function ({ rootState }) {
        let firebaseUser = rootState.auth.user
        let user = {
            displayName: firebaseUser.displayName,
            accountCreated: Date.now(),
            deletedAccount: false,
            doneSetup: false
        }
        let privateData = {

        }
        await db.collection('users').doc(firebaseUser.uid).set(user);
        await db.collection('users').doc(firebaseUser.uid).collection("data").doc('private').set(privateData);
    },
    updateProp: async function ({ }, prop) {
        await db.collection('users').doc(state.user.id).update(prop);
    },
    updatePrivateProp: async function ({ }, prop) {
        await db.collection('users').doc(state.user.id).collection("data").doc('private').update(prop);
    },
    deleteUser: firestoreAction(async ({ state, unbindFirestoreRef, dispatch, commit }) => {

        dispatch("globalRecommendations/removePseudo", state.user.displayName, { root: true } );
        await Promise.all([
            dispatch("conversations/deleteAllConversations", null, { root: true }),
            dispatch("social/deleteAllContacts", null, { root: true })]);

        db.collection("users").doc(state.user.id).delete()
        db.collection("users").doc(state.user.id).collection("data").doc('private').delete()

        unbindFirestoreRef('user');
        unbindFirestoreRef('privateUser');

        var user = auth.currentUser;
        let deleted = await user.delete().then(function () {
            commit("SET_USER", false);
            console.log("deleted !");
            return true;
        }).catch(function (error) {
            console.log(error.message);
            return false;
        });
        ga.event("User","deleted_account");
        return deleted;
    }),
    select: function ({ commit }, { key, value }) {
        commit("SELECT", { key, value });
    }
}
const getters = {
    
}

export default {
    state,
    mutations,
    actions,
    getters
}